import { createEffect } from 'effector'

export const signOutFx = createEffect(() => {
  window.location.href = '/auth/logout'
})

export const signInGithubFx = createEffect(() => {
  window.location.href = '/auth/login?provider=github'
})
